"use strict";

exports.__esModule = true;
var _Navbar = _interopRequireDefault(require("./Navbar"));
exports.default = _Navbar.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}